import { lazy } from 'react';
import { authRoles } from '../../../auth/authRoles';

const EcommercePage = lazy(() => import('./pages/EcommercePage'));
const RepartidoresPage = lazy(() => import('./pages/RepartidoresPage'));
const InboxConfigPage = lazy(() => import('./pages/InboxConfigPage'));
const PromocionesPage = lazy(() => import('./pages/PromocionesPage'));

export const ecommerceRoutesMap = {
  ecommerce: {
    path: '/ecommerce',
    name: 'Ecommerce',
    action: 'GESTION_ECOMMERCE',
  },
  repartidores: {
    path: '/ecommerce/repartidores',
    name: 'Repartidores',
    action: 'GESTION_ECOMMERCE',
  },
  inboxConfig: {
    path: '/ecommerce/inbox-config',
    name: 'in.box Config',
    action: 'GESTION_ECOMMERCE',
  },
  promociones: {
    path: '/ecommerce/promociones',
    name: 'Promociones',
    action: 'GESTION_ECOMMERCE',
  },
};

const ecommerceRoutes = [
  {
    path: ecommerceRoutesMap.ecommerce.path,
    element: <EcommercePage />,
    auth: authRoles.admin,
  },
  {
    path: ecommerceRoutesMap.repartidores.path,
    element: <RepartidoresPage />,
    auth: authRoles.admin,
  },
  {
    path: ecommerceRoutesMap.inboxConfig.path,
    element: <InboxConfigPage />,
    auth: authRoles.admin,
  },
  {
    path: ecommerceRoutesMap.promociones.path,
    element: <PromocionesPage />,
    auth: authRoles.admin,
  },
];

export default ecommerceRoutes;
